"use client";

import React, { useState } from "react";
import { GripVertical } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const transformations = [{
  id: 1,
  before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_reception_before.png",
  after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/spa_reception_after.png",
  caption: "Serene Reception Sanctuary"
}, {
  id: 2,
  before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/treatment_room_before.png",
  after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/treatment_room_after.png",
  caption: "Tranquil Therapy Suites"
}, {
  id: 3,
  before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/foot_bath_area_before.png",
  after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/foot_bath_area_after.png",
  caption: "Earthy Foot Ritual Lounge"
}, {
  id: 4,
  before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/relaxation_corner_before.png",
  after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/relaxation_corner_after.png",
  caption: "Soft-Lit Relaxation Nook"
}];
interface BeforeAfterSliderProps {
  before: string;
  after: string;
  caption: string;
}
function BeforeAfterSlider({
  before,
  after,
  caption
}: BeforeAfterSliderProps) {
  const [position, setPosition] = useState(50);
  return <div className="flex flex-col gap-6">
      <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-muted touch-pan-y shadow-md">
        {}
        <img src={before} alt={`Before ${caption}`} className="absolute inset-0 w-full h-full object-cover select-none" draggable={false} />

        {}
        <img src={after} alt={`After ${caption}`} className="absolute inset-0 w-full h-full object-cover select-none" style={{
        clipPath: `inset(0 ${100 - position}% 0 0)`
      }} draggable={false} />

        {}
        <div className="absolute top-0 bottom-0 w-[2px] bg-secondary pointer-events-none z-20" style={{
        left: `${position}%`
      }}>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-secondary rounded-lg flex items-center justify-center shadow-lg border-2 border-background">
            <GripVertical className="w-5 h-5 text-secondary-foreground" />
          </div>
        </div>

        {}
        <input type="range" min="0" max="100" value={position} onChange={e => setPosition(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize z-30 m-0" aria-label="Image comparison slider" />
      </div>
      <p className="text-primary font-default font-medium text-center text-lg md:text-xl">
        {caption}
      </p>
    </div>;
}
export default function StunningTransformations() {
  return;
}